module.exports = __webpack_public_path__ + "img/Windows.d6ebf89.svg";